import { useState } from 'react';

interface FacebookLoginButtonProps {
  className?: string;
  iconOnly?: boolean;
}

export function FacebookLoginButton({ className, iconOnly = false }: FacebookLoginButtonProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleFacebookLogin = async () => {
    try {
      setLoading(true);
      setError(null);

      const apiUrl = import.meta.env.VITE_API_URL || '';
      const response = await fetch(`${apiUrl}/api/auth/facebook/login`, {
        method: 'GET',
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to initiate Facebook login');
      }

      const data = await response.json();

      if (data.authUrl) {
        window.location.href = data.authUrl;
      } else {
        throw new Error('No authentication URL received');
      }
    } catch (err) {
      console.error('Facebook login error:', err);
      setError(err instanceof Error ? err.message : 'Login failed');
      setLoading(false);
    }
  };

  return (
    <div>
      <button
        type="button"
        onClick={handleFacebookLogin}
        disabled={loading}
        title="Sign in with Facebook"
        className={
          className ||
          (iconOnly
            ? 'flex items-center justify-center py-2 px-4 rounded-lg bg-[#1877F2] hover:bg-[#166FE5] text-white disabled:opacity-50 disabled:cursor-not-allowed transition-colors'
            : 'flex items-center justify-center w-full px-4 py-2 rounded-md shadow-sm bg-[#1877F2] hover:bg-[#166FE5] text-white disabled:opacity-50 disabled:cursor-not-allowed')
        }
      >
        {loading ? (
          <svg className="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
            />
          </svg>
        ) : (
          <>
            <svg
              className={iconOnly ? 'w-5 h-5' : 'w-5 h-5 mr-2'}
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
            </svg>
            {!iconOnly && 'Sign in with Facebook'}
          </>
        )}
      </button>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </div>
  );
}
